import React, { useState } from 'react';

import { Basic, Other } from './Body';
import Layout from '../Components/Layout';

export type Props = {
  pageTitle: string
  setInitialValues: (values: object | undefined) => void
  initialValues: object | undefined
};

const TyAdvancedSearchTymber: React.FC<Props> = ({
  pageTitle = 'Kdo hledá ten najde',
  setInitialValues,
  initialValues,
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Layout
      pageTitle={pageTitle}
      showModal={showModal}
      setShowModal={setShowModal}
      initialValues={initialValues}
      setInitialValues={setInitialValues}
    >
      <>
        <Basic />
        <Other />
      </>
    </Layout>
  );
};

export default TyAdvancedSearchTymber;
